import React, { FC, useContext, useState } from 'react';
import { PlayerID, TeamID } from '../../../scripts/models/common';
import { TeamModel } from '../../../scripts/models/models';
import { DataContext } from '../../context/dataLoader/DataLoader';
import RosterStats from './RosterStats';
import SeasonRecord from './SeasonRecord';

import './TeamDisplay.scss';

interface IProps {
  chosenTeam?: TeamID
}

const TeamDisplay: FC<IProps> = (props) => {
  const { chosenTeam } = props

  const data = useContext(DataContext)
  const [pitcher, setPitcher] = useState<PlayerID>();


  if (!chosenTeam) {
    return (
      <div className="TeamDisplay">
        Pick a team to view.
      </div>
    )
  }
  if (!data.teamCollections) {
    return (
      <div className="TeamDisplay">
        Loading...
      </div>
    )
  }
  const team: TeamModel = data.teamCollections.teamsById[chosenTeam];

  if (!team) {
    return (
      <div className="TeamDisplay">
        Loading...
      </div>
    )
  }



  return (
    <div className="TeamDisplay">
      <SeasonRecord team={team} pitcherHighlight={pitcher} />
      <RosterStats team={team} setPitcher={setPitcher} />


    </div>
  );
}
export default TeamDisplay;